/**
 * The two profile pop-ups — «PROFILE PAGE (profile picture pop-up)» and
 * «(nickname change pop-up)».
 *
 * They open from the profile itself: the avatar opens the picker, the «. . .»
 * beside the name opens the nickname form. Neither is a route; both are the
 * shared Dialog over the profile you were already on, which is what the boards
 * draw — the profile is still visible, blurred, behind them.
 */
import { useState } from 'react';
import { Dialog } from './Dialog.js';

/**
 * Ten portraits, four to a row, in the board's own order. The same set is the
 * ЛЮБИМЫЕ ПЕРСОНАЖИ row on the profile, so it lives here rather than being
 * written out twice.
 */
export const FACES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;

/** The board's own default: Мика, second in the grid, ticked. */
export const DEFAULT_FACE = 2;

export function AvatarPicker({
  face,
  onPick,
  onClose,
}: {
  face: number;
  onPick: (n: number) => void;
  onClose: () => void;
}) {
  return (
    <Dialog size="picker" label="Выберите аватар" title="Выберите аватар" onClose={onClose}>
      <div className="dlg-faces">
        {FACES.map((n) => (
          <button
            key={n}
            className={`dlg-face is-face-${n}`}
            aria-pressed={n === face}
            aria-label={`Аватар ${n}`}
            onClick={() => { onPick(n); onClose(); }}
          />
        ))}
      </div>
    </Dialog>
  );
}

export function NicknamePicker({
  name,
  onPick,
  onClose,
}: {
  name: string;
  onPick: (next: string) => void;
  onClose: () => void;
}) {
  const [draft, setDraft] = useState(name);
  const trimmed = draft.trim();

  return (
    <Dialog
      size="prompt"
      label="Выберите никнейм"
      title="Выберите никнейм"
      action="Подтвердить"
      actionDisabled={trimmed.length === 0}
      onAction={() => { onPick(trimmed); onClose(); }}
      onClose={onClose}
    >
      <input
        className="dlg-field"
        value={draft}
        autoFocus
        maxLength={24}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && trimmed) { onPick(trimmed); onClose(); } }}
        aria-label="Никнейм"
      />
    </Dialog>
  );
}
